import { render, staticRenderFns } from "./dmSelectRecord.vue?vue&type=template&id=1210d1b3"
import script from "./dmSelectRecord.ts?vue&type=script&lang=js&external"
export * from "./dmSelectRecord.ts?vue&type=script&lang=js&external"
import style0 from "./dmSelectRecord.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports